import $ from 'jquery';

var selectors = {
    accountIcon: '.js-header-user-account',
    linkClass: '.js-a-force-click'
};
var cssClasses = {
    hoverClassCss: 'hover'
};
var isAlreadyClicked = false;
var $accountIcon;
var $link;

export default function init() {
    $accountIcon = $(selectors.accountIcon);
    $link = $accountIcon.find(selectors.linkClass);

    // touchend is used to allow :hover state be triggered by browser
    $accountIcon.on('touchend', selectors.linkClass, function (event) {
        event.preventDefault();

        if (isAlreadyClicked) {
            isAlreadyClicked = false;
            toggleHoverClass(false);
            goToLinkAddress();
        } else {
            isAlreadyClicked = true;
            attachDocumentEvent();
            toggleHoverClass(true);
        }
    });

    $link.on('touchstart', function (event) {
        event.preventDefault();
    });
}

// fallback for mobile browsers, which don't support hover state
function toggleHoverClass(addOrRemove) {
    $accountIcon.toggleClass(cssClasses.hoverClassCss, addOrRemove);
}

function attachDocumentEvent() {
    $(window.document).on('touchstart.headerLink', function (event) {
        var target = event.target;

        // if header or children were clicked - skip. Appropriate event for header will take care
        while (target !== this) {
            if (target === $accountIcon[0]) {
                return;
            }

            target = target.parentNode;
        }

        isAlreadyClicked = false;
        deattachDocumentEvent();
        toggleHoverClass(false);
    });
}

function deattachDocumentEvent() {
    $(window.document).off('.headerLink');
}

function goToLinkAddress() {
    window.location.assign($link.attr('href'));
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/header/userAccount.js
 **/